<div class="container">
  <div class="survey-div">
    <ngx-spinner aria-hidden="true"></ngx-spinner>
    <span class="sr-only" aria-live="polite" role="status">{{ loadingMessage }}</span>
    @if (showQuestionSet) {
      <app-question-set></app-question-set>
    } @else {
      <!-- <app-welcome (formSubmitEmitter)="showSurveyOptions($event)"></app-welcome> -->
      <app-survey-options 
        (startSurveyEmitter)="updateQuestionSetView($event)">
      </app-survey-options>
    }
  </div>
</div>
